/* jshint ignore:start */

/*! js-cookie v3.0.0-beta.4 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,function(){var r=e.Cookies,n=e.Cookies=t();n.noConflict=function(){return e.Cookies=r,n}}())}(this,function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)e[n]=r[n]}return e}var t={read:function(e){return e.replace(/%3B/g,";")},write:function(e){return e.replace(/;/g,"%3B")}};return function r(n,i){function o(r,o,u){if("undefined"!=typeof document){"number"==typeof(u=e({},i,u)).expires&&(u.expires=new Date(Date.now()+864e5*u.expires)),u.expires&&(u.expires=u.expires.toUTCString()),r=t.write(r).replace(/=/g,"%3D"),o=n.write(String(o),r);var c="";for(var f in u)u[f]&&(c+="; "+f,!0!==u[f]&&(c+="="+u[f].split(";")[0]));return document.cookie=r+"="+o+c}}return Object.create({set:o,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var r=document.cookie?document.cookie.split("; "):[],i={},o=0;o<r.length;o++){var u=r[o].split("="),c=u.slice(1).join("="),f=t.read(u[0]).replace(/%3D/g,"=");if(i[f]=n.read(c,f),e===f)break}return e?i[e]:i}},remove:function(t,r){o(t,"",e({},r,{expires:-1}))},withAttributes:function(t){return r(this.converter,e({},this.attributes,t))},withConverter:function(t){return r(e({},this.converter,t),this.attributes)}},{attributes:{value:Object.freeze(i)},converter:{value:Object.freeze(n)}})}(t,{path:"/"})});

/* jshint ignore:end */

jQuery(function($) {

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };



    /*
     |----------------------------------------------------------------
     |  HASH SCROLL
     |
     |----------------------------------------------------------------
     */
     $('.advisor-type-filter').on('change',function(){

        console.log('asdffdas');

        var officeVal = $('.advisor-office-filter').val();
        var ptypeVal = $('.advisor-ptype-filter').val();
        var atypeVal = $(this).val();

        var location = atypeVal;

        var langStr = '';
        if($('html[lang="fr-FR"]').length){
            langStr = 'lang=fr&';
        }

        if( officeVal !== 'all-offices' ){
            location = atypeVal + '&office=' + officeVal;
        }
        if( ptypeVal !== 'all-property-type' ){
            location = atypeVal + '&ptype=' + ptypeVal;
        }
        if( officeVal !== 'all-offices' && ptypeVal !== 'all-property-type' ){
            location = atypeVal + '&ptype=' + ptypeVal + '&office=' + officeVal;
        }

        window.location.href = '/advisors/?' + langStr + 'atype=' + location;
        
     });


     $('.advisor-office-filter').on('change',function(){
        var officeVal = $(this).val();
        var ptypeVal = $('.advisor-ptype-filter').val();
        // var atypeVal = $('.advisor-type-filter').val();
        console.log(officeVal);

        var location = officeVal;

        var langStr = '';
        if($('html[lang="fr-FR"]').length){
            langStr = 'lang=fr&';
        }

        // if( atypeVal !== 'all-type' ){
        //     location = officeVal + '&atype=' + atypeVal;
        // }
        // if( officeVal !== 'all-offices' ){
        //     location = ptypeVal + '&office=' + officeVal;
        // }

        if(officeVal === 'all-offices' && ptypeVal === 'all-property-type') {
            if($('html[lang="fr-FR"]').length){
                window.location.href = '/advisors/?lang=fr';
            }
            else{
                window.location.href = '/advisors';
            }
        } else if(officeVal === 'all-offices' && ptypeVal !== 'all-property-type') {
            window.location.href = '/advisors/?' + langStr + 'ptype=' + ptypeVal;
        } else if (officeVal !== 'all-offices' && ptypeVal === 'all-property-type') {
            window.location.href = '/advisors/?' + langStr + 'office=' + officeVal;
        } else {
            window.location.href = '/advisors/?' + langStr + 'office=' + officeVal + '&ptype=' + ptypeVal;
        }

        // if( ptypeVal !== 'all-property-type' ){
        //     location = officeVal + '&ptype=' + ptypeVal;
        // }
        // if( officeVal !== 'all-offices' && ptypeVal !== 'all-property-type' ){
        //     location = officeVal + '&ptype=' + ptypeVal;
        // }
        // window.location.href = '/advisors/?office=' + location;
     });


     $('.advisor-ptype-filter').on('change',function(){
        var officeVal = $('.advisor-office-filter').val();
        var ptypeVal = $(this).val();

        console.log(ptypeVal);
        // var atypeVal = $('.advisor-type-filter').val();

        var location = ptypeVal;

        var langStr = '';
        if($('html[lang="fr-FR"]').length){
            langStr = 'lang=fr&';
        }

        if(officeVal === 'all-offices' && ptypeVal === 'all-property-type') {
            if($('html[lang="fr-FR"]').length){
                window.location.href = '/advisors/?lang=fr';
            }
            else{
                window.location.href = '/advisors';
            }
        } else if(officeVal === 'all-offices' && ptypeVal !== 'all-property-type') {
            window.location.href = '/advisors/?' + langStr + 'ptype=' + ptypeVal;
        } else if (officeVal !== 'all-offices' && ptypeVal === 'all-property-type') {
            window.location.href = '/advisors/?' + langStr + 'office=' + officeVal;
        } else {
            window.location.href = '/advisors/?' + langStr + 'office=' + officeVal + '&ptype=' + ptypeVal;
        }

        // // if( atypeVal !== 'all-type' ){
        // //     location = ptypeVal + '&atype=' + atypeVal;
        // // }
        // if( officeVal !== 'all-offices' ){
        //     location = ptypeVal + '&office=' + officeVal;
        // }
        // // if( officeVal !== 'all-offices' && atypeVal !== 'all-type' ){
        // //     location = ptypeVal + '&office=' + officeVal + '&atype=' + atypeVal;
        // // }

        // window.location.href = '/advisors/?ptype=' + location;
     });


     // News Section
     $('.news-cat-filter').on('change',function(){
        var categoryVal = $(this).val();
        var locationVal = $('.news-location-filter').val();
        var ptypeVal = $('.news-ptype-filter').val();

        var location = categoryVal;

        var langStr = '';
        if($('html[lang="fr-FR"]').length){
            langStr = 'lang=fr&';
        }

        if(categoryVal === 'all-categories' && locationVal === 'all-locations' && ptypeVal === 'all-property-type') {
            if($('html[lang="fr-FR"]').length){
                window.location.href = '/news-events/?lang=fr';
            }
            else{
                window.location.href = '/news-events';
            }
        } else if (categoryVal !== 'all-categories' && locationVal === 'all-locations' && ptypeVal === 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal;
        } else if (categoryVal === 'all-categories' && locationVal !== 'all-locations' && ptypeVal === 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'location=' + locationVal;
        } else if(categoryVal === 'all-categories' && locationVal === 'all-locations' && ptypeVal !== 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'ptype=' + ptypeVal;
        } else if(categoryVal !== 'all-categories' && locationVal !== 'all-locations' && ptypeVal === 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal + '&location=' + locationVal;
        } else if(categoryVal !== 'all-categories' && locationVal === 'all-locations' && ptypeVal !== 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal + '&ptype=' + ptypeVal;
        } else if(categoryVal === 'all-categories' && locationVal !== 'all-locations' && ptypeVal !== 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'location=' + locationVal + '&ptype=' + ptypeVal;
        } else {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal + '&location=' + locationVal + '&ptype=' + ptypeVal;
        }

     });

     $('.news-location-filter').on('change',function(){
        var locationVal = $(this).val();
        var categoryVal = $('.news-cat-filter').val();
        var ptypeVal = $('.news-ptype-filter').val();

        var location = locationVal;

        var langStr = '';
        if($('html[lang="fr-FR"]').length){
            langStr = 'lang=fr&';
        }

        if(categoryVal === 'all-categories' && locationVal === 'all-locations' && ptypeVal === 'all-property-type') {
            if($('html[lang="fr-FR"]').length){
                window.location.href = '/news-events/?lang=fr';
            }
            else{
                window.location.href = '/news-events';
            }
        } else if (categoryVal !== 'all-categories' && locationVal === 'all-locations' && ptypeVal === 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal;
        } else if (categoryVal === 'all-categories' && locationVal !== 'all-locations' && ptypeVal === 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'location=' + locationVal;
        } else if(categoryVal === 'all-categories' && locationVal === 'all-locations' && ptypeVal !== 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'ptype=' + ptypeVal;
        } else if(categoryVal !== 'all-categories' && locationVal !== 'all-locations' && ptypeVal === 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal + '&location=' + locationVal;
        } else if(categoryVal !== 'all-categories' && locationVal === 'all-locations' && ptypeVal !== 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal + '&ptype=' + ptypeVal;
        } else if(categoryVal === 'all-categories' && locationVal !== 'all-locations' && ptypeVal !== 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'location=' + locationVal + '&ptype=' + ptypeVal;
        } else {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal + '&location=' + locationVal + '&ptype=' + ptypeVal;
        }

     });

     $('.news-ptype-filter').on('change',function(){
        var ptypeVal = $(this).val();
        var categoryVal = $('.news-cat-filter').val();
        var locationVal = $('.news-location-filter').val();

        var location = ptypeVal;

        var langStr = '';
        if($('html[lang="fr-FR"]').length){
            langStr = 'lang=fr&';
        }

        if(categoryVal === 'all-categories' && locationVal === 'all-locations' && ptypeVal === 'all-property-type') {
            if($('html[lang="fr-FR"]').length){
                window.location.href = '/news-events/?lang=fr';
            }
            else{
                window.location.href = '/news-events';
            }
        } else if (categoryVal !== 'all-categories' && locationVal === 'all-locations' && ptypeVal === 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal;
        } else if (categoryVal === 'all-categories' && locationVal !== 'all-locations' && ptypeVal === 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'location=' + locationVal;
        } else if(categoryVal === 'all-categories' && locationVal === 'all-locations' && ptypeVal !== 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'ptype=' + ptypeVal;
        } else if(categoryVal !== 'all-categories' && locationVal !== 'all-locations' && ptypeVal === 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal + '&location=' + locationVal;
        } else if(categoryVal !== 'all-categories' && locationVal === 'all-locations' && ptypeVal !== 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal + '&ptype=' + ptypeVal;
        } else if(categoryVal === 'all-categories' && locationVal !== 'all-locations' && ptypeVal !== 'all-property-type') {
            window.location.href = '/news-events/?' + langStr + 'location=' + locationVal + '&ptype=' + ptypeVal;
        } else {
            window.location.href = '/news-events/?' + langStr + 'category=' + categoryVal + '&location=' + locationVal + '&ptype=' + ptypeVal;
        }

     });



    /*
     |----------------------------------------------------------------
     |  COOKIE
     |
     |----------------------------------------------------------------
     */
    const jsCookieAccept = function(){
      // ######################################## COOKIE EVENT
      // this is my cookie events
      const html = document.querySelector('html');
      //Cookies.remove('acceptmmcookie');
      var cookieWrapper = document.querySelector('.js--cookie-notification');
      if( cookieWrapper ){
        var closeButton = cookieWrapper.querySelector('.close');
        html.classList.add('is--cookie__notaccepted');
        // acceptButton.addEventListener('click',function(e){
        //   Cookies.set('acceptmmcookie', '1', { expires: 7200 });
        //   //html.classList.add('is--cookie__accepted');
        //   html.classList.remove('is--cookie__notaccepted');
        // });

        closeButton.addEventListener('click',function(e){
          Cookies.set('acceptmmcookie', '1', { expires: 7200 });
          //html.classList.add('is--cookie__accepted');
          html.classList.remove('is--cookie__notaccepted');
        });


        if( Cookies.get('acceptmmcookie') === '1' ){
          //html.classList.add('is--cookie__accepted');
          html.classList.remove('is--cookie__notaccepted');
        }else{
          //html.classList.remove('is--cookie__accepted');
          html.classList.add('is--cookie__notaccepted');
        }
      }
    };
    jsCookieAccept();



    /*
     |----------------------------------------------------------------
     |  HASH SCROLL
     |
     |----------------------------------------------------------------
     */
    function hashScroll(){
      $('a[href*=\\#]:not([href=\\#])').click(function() {
      if (window.location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && window.location.hostname === this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top - 140
          }, 600);
          return false;
        }
      }
      });
    }
    hashScroll();

    /*
     |----------------------------------------------------------------
     |  Mobile Trigger
     |  (targeting all .menu-trigger, so they're syncornized )
     |----------------------------------------------------------------
     */
    // $('.fs-menu-trigger').click(function(e) {
    //     e.preventDefault();

    //     $('body').toggleClass('menu-opened');
    //     $('.main-menu').slideToggle(250);
    // });

    $('.js-hamburger').click(function(e) {
        e.preventDefault();
        $('body').toggleClass('menu-opened');
    });


    /*
     |----------------------------------------------------------------
     |  Mobile Sub-menu Trigger
     |----------------------------------------------------------------
     */
    // $(".menu-item-has-children > a")
    //     .append('<span class="mobile-submenu-trigger"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>');

    // $(".mobile-submenu-trigger").click(function(e) {
    //     e.preventDefault();
    //     e.stopPropagation();

    //     $(this).toggleClass('opened');
    //     $(this).parent().siblings('.sub-menu').slideToggle();
    // });

    $('header .menu-item-has-children').on('click',function(){

        $(this).toggleClass('is--active');
        $('.sub-menu',this).toggleClass('is--open');

    });

    /*
     |----------------------------------------------------------------
     |  Smooth Scrolling
     |  (targeting all [data-smooth-scroll])
     |----------------------------------------------------------------
     */
    $('[data-smooth-scroll]').click(function(e) {
        var $target = $($(this).attr('data-smooth-scroll'));

        if ($target.size()) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: $target.offset().top - 50
            }, 250);
        }
    });

    /*
     |----------------------------------------------------------------
     |  Global Fancybox Trigger
     |----------------------------------------------------------------
     */
    $('.fancybox').fancybox();

    /*
     |----------------------------------------------------------------
     |  Slick
     |----------------------------------------------------------------
     */
     $('.portfolio-slider')
        .on('init', function() {
            $(".portfolio-thumbnail-grid .thumbnail").click(function(e) {
                var index = $(this).index();
                $(this).siblings().removeClass('active');
                $(this).addClass('active');
                $(".portfolio-slider").slick('slickGoTo', index);
            }).eq(0).addClass('active');
        })
        .on('beforeChange', function(e, slick, currentSlide, nextSlide) {
            $(".portfolio-thumbnail-grid .thumbnail.active").removeClass('active');
            $(".portfolio-thumbnail-grid .thumbnail").eq(nextSlide).addClass('active');
        });
    $('.portfolio-slider').slick({
        dots: false,
        draggable: false,
        swipe: false,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        customPaging: function(slider, i) {
            return '<i class="fa fa-circle" aria-hidden="true"></i>';
        }
    });

    /*
     |----------------------------------------------------------------
     |  Tabs
     |----------------------------------------------------------------
     */
    $(".tabs-holder").each(function() {
        var $self = $(this);
        var $controls = $('[data-tab]', $self);
        var $contents = $('[data-tab-id]', $self);

        $controls.click(function(e) {
            var target = $(this).attr('data-tab');
            var $target = $('[data-tab-id="'+target+'"]', $self);

            if ($target.size()) {
                e.preventDefault();

                $controls.removeClass('active');
                $(this).addClass('active');

                $contents.removeClass('active');
                $target.addClass('active');
            }
        });

        $controls.eq(0).trigger('click');
    });

    /*
     |----------------------------------------------------------------
     |  Search Form Trigger
     |----------------------------------------------------------------
     */
    $('#select-blog').on('change', function(){
        window.location.href = $( this ).children( 'option:selected' ).val();
    });

    /*
     |----------------------------------------------------------------
     |  FLEX CONTENT - ACCORD FEATURE
     |----------------------------------------------------------------
     */

     $('.accordion--feature').each(function(){
        var $title = $('.column--title',this);
        var $toggle = $('.accordion--toggle',this);
        $title.on('click',function(){
            $(this).parent().toggleClass('is--active');
        });

        $toggle.on('click',function(){
            $(this).parent().toggleClass('is--active');
        });
     });


     /*
     |----------------------------------------------------------------
     |  News & Events
     |----------------------------------------------------------------
     */
     if($('body.page-id-2858').length || $('body.page-id-2908').length){
       Cookies.set('back-url', window.location.href);

       var category = getUrlParameter('category');
       var location = getUrlParameter('location');
       var ptype = getUrlParameter('ptype');
       var paged = $('body[class*="page-paged-"]').length;

       if(category || location || ptype || paged){
        $(window).on('load', function(){
          $('html,body').animate({
            scrollTop: $('.news-section .module--filter').offset().top - 140
          }, 600);
        });
          
       }
     }

     if(Cookies.get('back-url')){
       $('.single-news-event .link-back').attr('href', Cookies.get('back-url'));
     }
     else{
       if($('html[lang="fr-FR"]').length){
          $('.single-news-event .link-back').attr('href', '/news-events/?lang=fr');
       }
       else{
          $('.single-news-event .link-back').attr('href', '/news-events/');
       }
     }


});
